import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'female-water-fasting': {
			// /water-fasting-f?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_water_fasting_ui_and_copy_optimization~1
			funnel: {
				id: 'ob-water-fasting-female-copy-optimization',
				locale: ['en'],
			},
		},
	},
]

export default config
